import { render, staticRenderFns } from "./data-exports-tab.vue?vue&type=template&id=abe4715a"
import script from "./data-exports-tab.vue?vue&type=script&lang=js"
export * from "./data-exports-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports